import { Styles } from "./style";

export default function SubjectTableLayout({ children = null, header = null, className }) {
  return (
    <Styles className={className}>
      <div className="mb-6">
        {header}
      </div>
      <div className="column start app-content">
        {children}
      </div>
    </Styles>
  )
}
